import moment from 'moment-timezone'
import FORMATS from 'constants/datetime'

const getMomentDate = (
  etaDate: Date | null,
  etaTime: string | null,
  timezone: string = 'America/New_York'
): moment.Moment => {
  const inputDate = moment(etaDate)
  const time = moment(etaTime, 'HH:mmA')
  const targetDate = moment(inputDate)
    .set('hours', time.get('hours'))
    .set('minutes', time.get('minute'))
    .tz(timezone)
  return targetDate
}

export const getFormattedDate = (
  etaDate: Date | null,
  etaTime: string | null,
  timezone: string = 'America/New_York'
): string | undefined => {
  if (!etaDate || !etaTime) {
    return undefined
  }
  const targetDate = getMomentDate(etaDate, etaTime, timezone)
  if (targetDate) {
    return targetDate.format(FORMATS.iso8601Format)
  }
  return undefined
}
